import { Keypair, PublicKey, TransactionInstruction } from "@solana/web3.js";
import BN from "bn.js";
import { ReferralProgram } from "../type";

export interface IUnstakeParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  escrowAddress: PublicKey;
  owner: PublicKey;
  payer: PublicKey;
  maxAmount: BN;
  unstakeKeypair?: Keypair;
}

export async function createUnstakeIx(
  params: IUnstakeParams,
): Promise<{ instruction: TransactionInstruction; unstakeKeypair: Keypair }> {
  const {
    referralProgram,
    stakingAddress,
    escrowAddress,
    owner,
    payer,
    maxAmount,
    unstakeKeypair: providedKeypair,
  } = params;

  const unstakeKeypair = providedKeypair ?? Keypair.generate();

  const instruction = await referralProgram.methods
    .unstake({
      maxAmount,
      padding0: Array(5).fill(new BN(0)),
    })
    .accountsPartial({
      unstake: unstakeKeypair.publicKey,
      escrow: escrowAddress,
      staking: stakingAddress,
      owner,
      payer,
    })
    .instruction();

  return { instruction, unstakeKeypair };
}
